import { useNavigate, useLocation } from "react-router-dom";
import chat from '../../icons/Chat_Icon.png'
import search from '../../icons/Search.png';
import archived from '../../icons/Archived.png';
import conversation_control from '../../icons/Conversation_Control.png';
import conversation_viewer from '../../icons/Conversation_Viewer.png';
import styled from "styled-components";
import Tooltip from "../tooltip/Tooltip";
import { ACTIVE_CONVERSATIONS, ARCHIVED_CONVERSATIONS, CONTACT_SEARCH, CONVERSATION_CONTROL, CONVERSATION_VIEWER } from "../../utils/constants";
import { useEffect } from "react";
import { simpleGTMDataLayer } from "../../utils/utilities";
import { useSelector } from "react-redux";


const SideNavStyle = styled.div`
  white-space: nowrap;
  background-color: #0173C6;
  width: 60px;

.menu-item:hover {
  cursor: pointer;
  background-color: #0853A4;
}

.menu-item.active {
  cursor: pointer;
  background-color: #0853A4;
}

ul {
  list-style-type: none;
  color: #fff;
  /* border-bottom: 1px solid rgba(255, 255, 255, 0.1); */
  margin: 0;
  padding: 0;
  li {
    /* border-bottom: 1px solid black; */
    display: block;
    padding: 12px;
    text-transform: uppercase;
}
`;

function SideNav({ setDisplayCustomerInHeader, path, setPath }: any) {
  const user = useSelector((state: any) => state.user)
  let history = useNavigate();
  let location = useLocation();

  useEffect(() => {
    setPath(location.pathname);
  });

  const handleClick = (path: any, pageName: string) => {
    history(path);
    setPath(path);
    if(pageName !== 'Contact Search'){
    simpleGTMDataLayer({
      csrId: user.userName,
      event: 'NavBar-Click',
      event_action: 'Button Click',
      event_category: window.location.pathname,
      event_label: 'Nav bar actions',
      event_value: `${user.fullName} clicked ${pageName} Page`
    });
    simpleGTMDataLayer({
      csrId: user.userName,
      event: 'NavBar-Click-Snowplow',
      event_action: 'Button Click',
      event_category: window.location.pathname + "/Snowplow",
      event_label: 'Nav bar actions',
      event_value: `${user.fullName} clicked ${pageName} Page`
    });
    }
  }

  return (
    <SideNavStyle data-testid="test-side-menu" className="side-menu" >
      <ul >
        <Tooltip content={CONTACT_SEARCH} direction="right" styles={{ fontSize: 16 }}>
          <li className={`menu-item ${path?.includes("/search") ? "active" : ''}`} onClick={() => handleClick("/search?advancedSearch=false", "Contact Search")}>
            <img src={search} alt="#" height={30} width={30} />
          </li>
        </Tooltip>
        <Tooltip content={ACTIVE_CONVERSATIONS} direction="right" styles={{ fontSize: 16 }}>
          <li className={`menu-item ${(path?.includes("/message")) ? "active" : ''}`} onClick={() => handleClick("/message", "Active Conversations")}>
            <img src={chat} alt="#" height={30} width={30} />
          </li>
        </Tooltip>
        <Tooltip content={ARCHIVED_CONVERSATIONS} direction="right" styles={{ fontSize: 16 }}>
          <li className={`menu-item ${(path?.includes("/archived-conversations")) ? "active" : ''}`} onClick={() => handleClick("/archived-conversations", "Archived Conversations")}>
            <img src={archived} alt="#" height={30} width={30} />
          </li>
        </Tooltip>
        <Tooltip content={CONVERSATION_CONTROL} direction="right" styles={{ fontSize: 16 }}>
          <li className={`menu-item ${path?.includes("/conversation-control") ? "active" : ''}`} onClick={() => handleClick("/conversation-control", "Conversation Control")}>
            <img src={conversation_control} alt="#" height={30} width={30} />
          </li>
        </Tooltip>
        <Tooltip content={CONVERSATION_VIEWER} direction="right" styles={{ fontSize: 16 }}>
          <li className={`menu-item ${path?.includes("/conversation-viewer") ? "active" : ''}`} onClick={() => handleClick("/conversation-viewer", "Conversation Viewer")}>
            <img src={conversation_viewer} alt="#" height={30} width={30} />
          </li>
        </Tooltip>

      </ul>
    </SideNavStyle>
  );
}

export default SideNav;
